/**
* @ngdoc service
* @name  sharebase-app.sbaFolderDetailsDataStore
* 
* @description 
* A datastore used to retrieve the details of a folder. 
**/
export function FolderDetailsDataStoreFactory(
	$q:ng.IQService,
	sbFolderService,
	sbFolderDetailService,
	utils
) {
	let _details = null;
	let _activities = [];
	let _folder = null;

	// flag used to determine if the folder details panel is open
	let _isOpen = false;

	// Used to debounce API requests for loading the folder details.
	return {
		/**
		* @ngdoc method
		* @name sbaFolderDetailsDataStore#load
		* @methodOf sharebase-app.sbaFolderDetailsDataStore
		* @kind function
		*
		* @description
		* Loads a folder's details
		* 
		* @param {object} folder A folder resource.
		* @param {Function} cb A callback that will be executed when the load has completed or encountered an error.
		*/
		load: utils.debounce(loadFolderDetails, 300),

		/**
		* @ngdoc method
		* @name sbaFolderDetailsDataStore#loadActivities
		* @methodOf sharebase-app.sbaFolderDetailsDataStore
		* @kind function
		*
		* @description
		* Loads a folder's activities
		* 
		*/
		loadActivities: utils.debounce(loadFolderActivities, 300),

		/**
		* @ngdoc property
		* @name sbaFolderDetailsDataStore#details
		* @propertyOf sharebase-app.sbaFolderDetailsDataStore
		* @kind property
		*
		* @description
		* A given folder's details
		* 
		* @returns {array} An object of folders's details
		*/
		get details() { return _details; },

		/**
		* @ngdoc property
		* @name sbaFolderDetailsDataStore#activities
		* @propertyOf sharebase-app.sbaFolderDetailsDataStore
		* @kind property
		*
		* @description
		* Activities for the currently loaded folder.
		*
		* @returns {array} An array of the loaded folder's activities.
		*/
		get activities() { return _activities; },

		/**
		 * @ngdoc property
		 * @name sbaFolderDetailsDataStore#isOpen
		 * @propertyOf sharebase-app.sbaFolderDetailsDataStore
		 * @kind function
		 * 
		 * @description
		 * Check if the details panel is open
		 */
		get isOpen() { return _isOpen; },
		set isOpen(val) { _isOpen = val; },

		/**
		 * @ngdoc method
		 * @name sbaFolderDetailsDataStore#reloadDetails
		 * @methodOf sharebase-app.sbaFolderDetailsDataStore
		 * @kind function
		 * 
		 * @description
		 * Reload the folder details if, and only if, the details panel is
		 * open and the provided folder id is the same as the details that
		 * were already loaded.
		 */
		reloadDetails: reloadDetails
	};

	function loadFolderDetails(folderId) {
		let p = $q.resolve(_folder);

		//ensure folderId is a number
		folderId = +folderId;

		if(_folder == null || folderId !== _folder.FolderId) {
			p = sbFolderService.getFolder(folderId);
		}

		return p
			.then(function(folder) {
				_folder = folder;
				return sbFolderDetailService.getFolderDetails(folder);
			})
			.then(function(details) {
				_details = {
					dateCreated: details.dateCreated,
					dateModified: details.dateModified,
					owner: details.owner,
					totalFiles: details.totalFiles
				};
				_activities = null;

				return _details;
			});
	}

	function loadFolderActivities(folderId) {
		let p = $q.resolve(_folder);
		
		//ensure folderId is a number
		folderId = +folderId;

		if(_folder == null || folderId !== _folder.FolderId) {
			p = sbFolderService.getFolder(folderId);
		}

		return p
			.then(function (folder) {
				_folder = folder;
				return sbFolderDetailService.getFolderActivities(folder);
			})
			.then(function (activities) {
				_activities = activities;
				return _activities;
			});
	}

	function reloadDetails(folder) {
		if (_isOpen && folder.folderId === _folder.FolderId) {
			loadFolderDetails(folder);
		}
	}
}

FolderDetailsDataStoreFactory.$inject = [
	'$q',
	'sbFolderService',
	'sbFolderDetailService',
	'utils'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/folderDetailsDataStore.ts